import { __extends } from "tslib";
import { MappingMode } from '@awayjs/renderer';
import { TextureBase } from './TextureBase';
/**
 *
 */
var Texture2D = /** @class */ (function (_super) {
    __extends(Texture2D, _super);
    function Texture2D(mappingMode) {
        if (mappingMode === void 0) { mappingMode = null; }
        var _this = _super.call(this) || this;
        _this._mappingMode = mappingMode || MappingMode.LINEAR;
        return _this;
    }
    Object.defineProperty(Texture2D.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return Texture2D.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Texture2D.assetType = '[texture Texture2D]';
    return Texture2D;
}(TextureBase));
export { Texture2D };
